import { render, staticRenderFns } from "./Localization.vue?vue&type=template&id=b329e88e&scoped=true"
import script from "./Localization.vue?vue&type=script&lang=ts"
export * from "./Localization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b329e88e",
  null
  
)

export default component.exports